var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 58.5,
    height: 58.5,
    rx: 29.25,
    fill: "#0E0924"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 58.5,
    height: 58.5,
    rx: 29.25,
    stroke: "url(#paint0_linear_1036_63)",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1036_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2496 20.5838L26.7002 20.5838C26.3943 20.5891 26.1028 20.7143 25.8883 20.9325C25.6739 21.1507 25.5538 21.4444 25.5538 21.7503C25.5538 22.0562 25.6739 22.3499 25.8883 22.568C26.1028 22.7862 26.3943 22.9114 26.7002 22.9168L35.4332 22.9168L20.9255 37.4245C20.7067 37.6433 20.5838 37.94 20.5838 38.2494C20.5838 38.5589 20.7067 38.8556 20.9255 39.0744C21.1443 39.2932 21.441 39.4161 21.7504 39.4161C22.0598 39.4161 22.3566 39.2932 22.5754 39.0744L37.0831 24.5667V33.2997C37.0804 33.4546 37.1086 33.6085 37.166 33.7523C37.2234 33.8962 37.3089 34.0272 37.4175 34.1377C37.5261 34.2482 37.6556 34.336 37.7984 34.3959C37.9413 34.4558 38.0947 34.4866 38.2496 34.4866C38.4045 34.4866 38.5579 34.4558 38.7007 34.3959C38.8436 34.336 38.9731 34.2482 39.0817 34.1377C39.1903 34.0272 39.2758 33.8962 39.3332 33.7523C39.3906 33.6085 39.4188 33.4546 39.4161 33.2997L39.4161 21.7503C39.416 21.4409 39.2931 21.1442 39.0744 20.9255C38.8556 20.7067 38.5589 20.5838 38.2496 20.5838Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1036_63",
    x1: 9,
    y1: 8.4,
    x2: 51.6,
    y2: 51.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5D5D5D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1036_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10.2012 30) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectarrow);
export default __webpack_public_path__ + "static/media/projectarrow.275438f8a4c8760423ccbc18c057509d.svg";
export { ForwardRef as ReactComponent };